<template>
  <div class="container-fluid h-100">
    <template v-if="href === ''">
      <div class="row text-center">
        <div class="col-12 bg-blue-200 py-3">
          <div class="container">
            <div class="row">
              <div class="col-12 d-flex flex-column py-5">
                <div class="mt-auto">
                  <h1 class="h2 text-blue-700">
                    Vous avez des documents en attente de signature !
                  </h1>
                </div>
                <div class="mb-auto">
                  Pour avoir accès à vos attestations, merci de suivre la procédure pour signer vos
                  documents
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row mt-3">
          <div
            class="col-12 text-center mb-4"
            style="margin-top: -2em"
          >
            <img
              :src="aws + '/unicorn-feather.png'"
              width="250"
              class="img-fluid"
            >
          </div>
          <div class="col-12 d-flex">
            <v-loader
              :next="sign"
              title="Signer les documents"
              color="warning"
              class="px-6 mx-auto"
            />
          </div>
        </div>
      </div>
    </template>
    <iframe
      v-else
      id="signature"
      _target="parent"
      :src="href"
      class="w-100"
      style="min-height: calc(100vh - 160px)"
      frameborder="0"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import Loader from '@/components/common/helpers/Loader.vue';

export default {
  name: 'ClientSignature',
  components: {
    'v-loader': Loader,
  },
  data() {
    return {
      href: '',
    };
  },
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
    ...mapGetters({
      signatures: 'company/signatures',
    }),
  },
  mounted() {
    window.addEventListener(
      'message',
      (event) => {
        this.eventMethod(event);
      },
      false
    );
  },
  methods: {
    eventMethod(event) {
      if (event.origin === window.origin && event.data === 'Hello there, general Kenobi') {
        this.$store.dispatch('company/setValue', {
          signatures: [],
          signaturesJustCompleted: true,
        });
        this.$router.replace('/client?from=signature');
      }
    },
    async sign() {
      try {
        if (!(this.signatures?.length)) {
          return this.$router.replace('/client/home');
        }
        const current = this.signatures.filter((signature) => signature.status === 'WAITING');
        if (current && current.length > 0) {
          const success = await this.$store.dispatch(
            'download/findSignatureUrlFromId',
            current[0].id
          );
          this.href = success.data.signatureUrl;
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.resolve(error);
      }
    },
  },
};
</script>
